<template>
  <div class="agent-permissions-group">
    <header class="agent-permissions-group__title">
      {{ $t('AGENT.GENERAL_PERMISSIONS.GROUP_TITLE') }}
    </header>
    <AgentPermissionsList
      size="big"
      :key-fn="({ property }) => property"
      :active-fn="({ property }) => property"
      :active="value"
      class="agent-permissions-group__list"
      :items="translatedItems"
      @click="emitValue"
    />
  </div>
</template>

<script>
import AgentPermissionsList from './AgentPermissionsList';

import { translatePermissionCategory } from './utils/permissionsTranslators';

export default {
  name: 'AgentPermissionsGroup',
  components: {
    AgentPermissionsList,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: {
      required: true,
      type: String,
    },
  },
  computed: {
    translatedItems() {
      return this.items.map(item => ({
        title: translatePermissionCategory(item),
        property: item,
      }));
    },
  },
  methods: {
    emitValue({ property }) {
      this.$emit('input', property);
    },
  },
};
</script>

<style lang="scss">
.agent-permissions-group {
  display: flex;
  flex-direction: column;

  &__title {
    font-weight: bold;
    color: $lb-medium-black;
    font-size: rem-calc(15px);
  }

  &__list {
    flex: 1 1 0;
    margin: $global-margin 0 0;
  }
}
</style>
